<template>
  <div class="sidebar sidebar-style-2" :data-background-color="darkSidebar ? 'dark' : ''">
    <div class="sidebar-wrapper scrollbar scrollbar-inner">
      <div class="sidebar-content">
        <ul class="nav nav-primary">
          <li class="nav-item border-active" v-if="user.active && !user.freeze" @click="hideMenu()" :class="{ active: currentPage === 'NewDistribution' }" v-tooltip.left="{ content: $t('new_release'), delay: 0, class: 'tooltip-custom' }">
            <router-link :to="getNewDistributionUrl()">
              <i class="fas fa-plus"></i>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Dashboard' }" v-tooltip.left="{ content: 'Dashboard', delay: 0, class: 'tooltip-custom' }">
            <router-link to="/dashboard">
              <i class="flaticon-home"></i>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Distributions' }" v-tooltip.left="{ content: $t('my_releases'), delay: 0, class: 'tooltip-custom' }">
            <router-link to="/distributions">
              <i class="flaticon-music-player"></i>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Artists' }" v-tooltip.left="{ content: $t('artists'), delay: 0, class: 'tooltip-custom' }">
            <router-link to="/artists">
              <i class="flaticon-users"></i>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Analytics' }" v-tooltip.left="{ content: ('Analytics '+((user.subscription)?'Pro':'')), delay: 0, class: 'tooltip-custom' }">
            <router-link to="/analytics">
              <i class="flaticon-graph-2"></i>
            </router-link>
          </li>
          <li class="nav-item submenu" @click="hideMenu()" :class="{ active: currentPage === 'ExtraTools' }" v-tooltip.left="{ content: $t('extra_tools'), delay: 0, class: 'tooltip-custom' }">
            <router-link to="/tools">
              <i class="fa fa-toolbox"></i>
            </router-link>
          </li>
          <li class="nav-item submenu" @click="hideMenu()" :class="{ active: currentPage === 'Feed' }" v-tooltip.left="{ content: $t('latest_releases'), delay: 0, class: 'tooltip-custom' }">
            <router-link to="/feed">
              <i class="fas fa-compact-disc"></i>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Upgrade' }" v-if="!user.subscription" v-tooltip.left="{ content: $t('upgrade_to_pro'), delay: 0, class: 'tooltip-custom' }">
            <router-link to="/upgrade">
              <i class="fa fa-rocket text-primary"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Artists from '../services/artists'
import Public from '../services/public'

export default {
  name: 'Sidebar',
  data: function () {
    return {
      locationSettings: {},
      isMobileApp: navigator.userAgent.indexOf('gonative') >= 0,
      currentPage: this.$route.name,
      defaultImage: '/static/img/img-placeholder-dark.jpg',
      user: {},
      darkSidebar: false,
      artists: [],
      visibility: true
    }
  },
  watch: {
    $route (to, from) {
      this.currentPage = to.name

      if (this.$route.path.match(/challenges/)) {
        this.darkSidebar = true
      } else {
        this.darkSidebar = false
      }
    }
  },
  methods: {
    getArtists: function () {
      Artists.getAll({ limit: 1 }).then(response => {
        this.artists = response.data
      })
    },
    getNewDistributionUrl: function () {
      if (this.artists.length) {
        if (this.locationSettings.hide_basic && !this.user.subscription) {
          return `/upgrade?from=sidebar_location_limit`
        } else {
          return `/new-distribution`
        }
      } else {
        return `/new-artist?distribution=true`
      }
    },
    hideMenu: function () {
      if (window.$(window).width() < 500 && window.$('html').hasClass('nav_open')) {
        window.$('html').removeClass('nav_open')
      }
    }
  },
  created: function () {
    this.user = this.$user

    this.$eventBus.$on('updateUser', user => {
      this.user = user
    })

    this.$eventBus.$on('updateArtists', () => {
      this.getArtists()
    })

    if (this.$route.path.match(/challenges/)) {
      this.darkSidebar = true
    } else {
      this.darkSidebar = false
    }

    this.getArtists()

    Public.getLocationSettings().then(responseSettings => {
      this.locationSettings = responseSettings.data
    })
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
.avatar-sm {
  position: relative;

  .fa-certificate {
    position: absolute;
    top: -3px;
    left: -3px;
  }
}
.dropright{
  .dropdown-menu{
    left: 20px !important;
  }
  .nav-collapse{
    width: 210px;
    margin: 0;
    padding: 0;
    a {
      border-radius: 0px !important;
    }
  }
}

::-webkit-scrollbar {
  width: 1px;
}
.sidebar, .sidebar{
  width: 75px;
}
.sidebar .sidebar-wrapper, .sidebar .sidebar-wrapper{
  overflow: inherit;
}
.main-panel {
  width: calc(100% - 75px);
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarCollapse.vue